import { defineMessages } from 'react-intl';
const i18nKey = 'InstitutionsTab';
const messages = defineMessages({
  // Institutions tab
  institutionsTitle: {
    id: `${i18nKey}.institutionsTitle`,
    defaultMessage: 'Our clients',
    description: `
    #Component: TextHeadline
    #CharLimit: 35
    #Context: Description column title`
  },
  institutionsDescription: {
    id: `${i18nKey}.institutionsDescription`,
    defaultMessage: 'Trusted by institutions and government.',
    description: `
    #Component: TextLabel2
    #CharLimit: 100
    #Context: Description column text content`
  },
  institutionsLinkText: {
    id: `${i18nKey}.institutionsLinkText`,
    defaultMessage: 'Learn more',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Description column link text`
  },
  mobileNavBarLinkText: {
    id: `${i18nKey}.mobileNavBarLinkText`,
    defaultMessage: 'See all',
    description: `
    #Component: Button
    #CharLimit: 50
    #Context: Navbar link text for mobile`
  },
  prime: {
    id: `${i18nKey}.prime`,
    defaultMessage: 'PRIME',
    description: `
    #Component: Link
    #CharLimit: 35
    #Context: Prime product label (CharLimit autocalculated to 35)`
  },
  primeDescription: {
    id: `${i18nKey}.primeDescription`,
    defaultMessage: 'Integrated trading, finance, and custody',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: Prime product description (CharLimit autocalculated to 65)`
  },
  markets: {
    id: `${i18nKey}.markets`,
    defaultMessage: 'MARKETS',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Markets product label (CharLimit autocalculated to 40)`
  },
  exchange: {
    id: `${i18nKey}.exchange`,
    defaultMessage: 'Exchange',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Exchange page label (CharLimit autocalculated to 40)`
  },
  exchangeDescription: {
    id: `${i18nKey}.exchangeDescription`,
    defaultMessage: 'Spot markets for high-frequency trading',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Exchange Coinbase description (CharLimit autocalculated to 70)`
  },
  institutional: {
    id: `${i18nKey}.institutional`,
    defaultMessage: 'Institutional',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: institutional page label (CharLimit autocalculated to 45)`
  },
  institutionalDescription: {
    id: `${i18nKey}.institutionalDescription`,
    defaultMessage: 'Solutions for institutional investors',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Coinbase Institutional description (CharLimit autocalculated to 80)`
  },
  derivativesExchange: {
    id: `${i18nKey}.derivativesExchange`,
    defaultMessage: 'Derivatives Exchange',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Derivatives Exchange product label (CharLimit autocalculated to 55)`
  },
  derivativesExchangeDescription: {
    id: `${i18nKey}.derivativesExchangeDescription`,
    defaultMessage: 'Trade an accessible futures market',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Derivatives product description (CharLimit autocalculated to 75)`
  },
  internationalExchange: {
    id: `${i18nKey}.internationalExchange`,
    defaultMessage: 'International Exchange',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: International Exchange product label (CharLimit autocalculated to 60)`
  },
  internationalExchangeDescription: {
    id: `${i18nKey}.internationalExchangeDescription`,
    defaultMessage: 'Access perpetual futures markets',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: International Exchange Coinbase description (CharLimit autocalculated to 85)`
  },
  tradingAndFinancing: {
    id: `${i18nKey}.tradingAndFinancing`,
    defaultMessage: 'Trading and Financing',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Trading and Financing product label`
  },
  tradingAndFinancingDescription: {
    id: `${i18nKey}.tradingAndFinancingDescription`,
    defaultMessage: 'Professional prime brokerage services',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Trading and Financing Coinbase description`
  },
  custody: {
    id: `${i18nKey}.custody`,
    defaultMessage: 'Custody',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Custody product label`
  },
  custodyDescription: {
    id: `${i18nKey}.custodyDescription`,
    defaultMessage: 'Securely store all your digital assets',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Custody Coinbase description`
  },
  onchainWallet: {
    id: `${i18nKey}.onchainWallet`,
    defaultMessage: 'Onchain Wallet',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Onchain Wallet product label`
  },
  onchainWalletDescription: {
    id: `${i18nKey}.onchainWalletDescription`,
    defaultMessage: 'Intitutional-grade wallet to get onchain',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Onchain Wallet Coinbase description`
  },
  verifiedPools: {
    id: `${i18nKey}.verifiedPools`,
    defaultMessage: 'Verified Pools',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Verified Pools product label`
  },
  verifiedPoolsDescription: {
    id: `${i18nKey}.verifiedPoolsDescription`,
    defaultMessage: 'Transparent, verified liquidity pools',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Verified Pools Coinbase description`
  },
  // link titles
  primeLinkTitle: {
    id: `${i18nKey}.primeLinkTitle`,
    defaultMessage: 'Prime - Integrated trading, finance, and custody',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: Prime link title (CharLimit autocalculated to 80)`
  },
  exchangeLinkTitle: {
    id: `${i18nKey}.exchangeLinkTitle`,
    defaultMessage: 'Coinbase Exchange - Spot markets for high-frequency trading',
    description: `
    #Component: Link
    #CharLimit: 70
    #Context: Exchange link title (CharLimit autocalculated to 70)`
  },
  institutionalLinkTitle: {
    id: `${i18nKey}.institutionalLinkTitle`,
    defaultMessage: 'Solutions for institutional investors',
    description: `
    #Component: Link
    #CharLimit: 80
    #Context: institutional link title (CharLimit autocalculated to 80)`
  },
  derivativesExchangeLinkTitle: {
    id: `${i18nKey}.derivativesExchangeLinkTitle`,
    defaultMessage: 'Coinbase Derivatives Exchange - Trade an accessible futures market',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Derivatives link title (CharLimit autocalculated to 75)`
  },
  internationalExchangeLinkTitle: {
    id: `${i18nKey}.internationalExchangeLinkTitle`,
    defaultMessage: 'Coinbase International Exchange - Access perpetual futures markets',
    description: `
    #Component: Link
    #CharLimit: 85
    #Context: International Exchange link title (CharLimit autocalculated to 85)`
  },
  tradingAndFinancingLinkTitle: {
    id: `${i18nKey}.tradingAndFinancingLinkTitle`,
    defaultMessage: 'Trading and Financing - Professional prime brokerage services',
    description: `
    #Component: Link
    #CharLimit: 120
    #Context: Trading and Financing link title`
  },
  custodyLinkTitle: {
    id: `${i18nKey}.custodyLinkTitle`,
    defaultMessage: 'Custody - Securely store all your digital assets',
    description: `
    #Component: Link
    #CharLimit: 120
    #Context: Custody link title`
  },
  onchainWalletLinkTitle: {
    id: `${i18nKey}.onchainWalletLinkTitle`,
    defaultMessage: 'Onchain Wallet - Intitutional-grade wallet to get onchain',
    description: `
    #Component: Link
    #CharLimit: 120
    #Context: Onchain Wallet link title`
  },
  verifiedPoolsLinkTitle: {
    id: `${i18nKey}.verifiedPoolsLinkTitle`,
    defaultMessage: 'Verified Pools - Access verified pools',
    description: `
    #Component: Link
    #CharLimit: 120
    #Context: Verified Pools link title`
  },
  // Icon alt text
  custodyIconAltText: {
    id: `${i18nKey}.custodyIconAltText`,
    defaultMessage: 'Coinbase Custody Icon',
    description: `
    #Component: Link
    #CharLimit: 60
    #Context: Alternative info for Custody Icon image (CharLimit autocalculated to 60)`
  },
  primeIconAltText: {
    id: `${i18nKey}.primeIconAltText`,
    defaultMessage: 'Coinbase Prime Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for Prime Icon image (CharLimit autocalculated to 55)`
  },
  exchangeIconAltText: {
    id: `${i18nKey}.exchangeIconAltText`,
    defaultMessage: 'Exchange Icon',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Alternative info for Exchange Icon image (CharLimit autocalculated to 45)`
  },
  institutionalIconAltText: {
    id: `${i18nKey}.institutionalIconAltText`,
    defaultMessage: 'institutional Icon',
    description: `
    #Component: Link
    #CharLimit: 55
    #Context: Alternative info for institutional Icon image (CharLimit autocalculated to 55)`
  },
  derivativesExchangeIconAltText: {
    id: `${i18nKey}.derivativesExchangeIconAltText`,
    defaultMessage: 'Coinbase Derivatives Exchange Icon',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Alternative info for Derivatives Exchange icon image (CharLimit autocalculated to 75)`
  },
  internationalExchangeIconAltText: {
    id: `${i18nKey}.internationalExchangeIconAltText`,
    defaultMessage: 'International Exchange Icon',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: Alternative info for International Exchange icon image (CharLimit autocalculated to 65)`
  },
  privateClient: {
    id: `${i18nKey}.privateClient`,
    defaultMessage: 'Private Client',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Private Client product label (CharLimit autocalculated to 50)`
  },
  privateClientDescription: {
    id: `${i18nKey}.privateClientDescription`,
    defaultMessage: 'For trusts, family offices, UHNWIs',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Private Client product description (CharLimit autocalculated to 75)`
  },
  privateClientLinkTitle: {
    id: `${i18nKey}.privateClientLinkTitle`,
    defaultMessage: 'Coinbase Private Client - For trusts, family offices, and UHNWIs',
    description: `
    #Component: Link
    #CharLimit: 115
    #Context: Private Client link title (CharLimit autocalculated to 115)`
  },
  privateClientIconAltText: {
    id: `${i18nKey}.privateClientAltText`,
    defaultMessage: 'Coinbase Private Client Icon',
    description: `
    #Component: Link
    #CharLimit: 65
    #Context: Alternative info for Private Client icon image (CharLimit autocalculated to 65)`
  },
  staking: {
    id: `${i18nKey}.staking`,
    defaultMessage: 'Staking',
    description: `
    #Component: Link
    #CharLimit: 40
    #Context: Title for Staking (CharLimit autocalculated to 40)`
  },
  stakingDescription: {
    id: `${i18nKey}.stakingDescription`,
    defaultMessage: 'Explore staking across our products',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Description on a link to staking page (CharLimit autocalculated to 75)`
  },
  stakingLinkTitle: {
    id: `${i18nKey}.stakingLinkTitle`,
    defaultMessage: 'Staking - Explore staking across our products',
    description: `
    #Component: Link
    #CharLimit: 75
    #Context: Link to staking page (CharLimit autocalculated to 75)`
  },
  stakingIconAltText: {
    id: `${i18nKey}.stakingIconAltText`,
    defaultMessage: 'Staking logo',
    description: `
    #Component: Link
    #CharLimit: 45
    #Context: Image Alt Description (CharLimit autocalculated to 45)`
  },
  tradingAndFinancingIconAltText: {
    id: `${i18nKey}.tradingAndFinancingIconAltText`,
    defaultMessage: 'Trading and Financing Icon',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Alternative info for Trading and Financing icon image`
  },
  onchainWalletIconAltText: {
    id: `${i18nKey}.onchainWalletIconAltText`,
    defaultMessage: 'Onchain Wallet Icon',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Alternative info for Onchain Wallet icon image`
  },
  verifiedPoolsIconAltText: {
    id: `${i18nKey}.verifiedPoolsIconAltText`,
    defaultMessage: 'Verified Pools Icon',
    description: `
    #Component: Link
    #CharLimit: 50
    #Context: Alternative info for Verified Pools icon image`
  }
});
export { messages as default };
//# sourceMappingURL=messages.js.map
